import React, { useState, useEffect } from "react";
import "./../../../../assets/css/purchase/form.css";

// Components
import Breadcrumbs from "../../../components/Breadcrumbs";
import FormAction from "../../../components/Actions/FormAction";
import {
  deleteData,
  getAlert,
  insertData,
  updateData,
} from "../../../../utils/SamuiUtils";

const Form = ({
  callInitialize,
  mode,
  name,
  formData,
  setFormData,
  selectedData,
  dataAPtype,
}) => {
  const [initialFormData, setInitialFormData] = useState({});

  // useEffect(() => {
  //   const compId = localStorage.getItem("company");
  //   if (compId) {
  //     setFormData((prevData) => ({
  //       ...prevData,
  //       comp_id: compId,
  //     }));
  //   }
  // }, [setFormData]);

  useEffect(() => {
    if (mode === "I") {
      const initialData = {
        DocType_Id: 0,
        DocType_Name: "",
        DocType_Status: "Y",
      };
      // กำหนดค่าเริ่มต้นให้กับ form data
      setFormData(initialData);
      // กำหนดค่าเริ่มต้นให้กับ initial form data
      setInitialFormData(initialData);
    } else if (mode === "U") {
      const initialData = {
        DocType_Id: selectedData.DocType_Id,
        DocType_Name: selectedData.DocType_Name,
        DocType_Status: selectedData.DocType_Status,
      };
      // อัปเดตค่าให้กับ form data
      setFormData(initialData);
      // อัปเดตค่าให้กับ initial form data
      setInitialFormData(initialData);
    }
  }, [mode, setFormData, selectedData]);

  // ฟังก์ชันที่ใช้ในการเปลี่ยนค่าของข้อมูลในฟอร์ม
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleInsertAP = async () => {
    try {
      const { DocType_Id, ...dataToInsert } = formData;
      const fields = Object.keys(dataToInsert).join(", ");
      const values = Object.values(dataToInsert);

      const res = await insertData("Tb_Set_DocType", fields, values);

      if (res?.status === "OK") {
        getAlert("OK", "บันทึกสำเร็จ");
        callInitialize();
      } else {
        getAlert("FAILED", res?.message || "ไม่สามารถบันทึกข้อมูลได้");
      }
    } catch (error) {
      console.error("Error in handleInsertAP:", error);
      getAlert("FAILED", "ไม่สามารถบันทึกข้อมูลได้");
    }
  };

  const formatValues = (data) => {
    const { DocType_Id, ...rest } = data;
    return rest;
  };

  const handleUpdateAP = async () => {
    try {
      const where = { DocType_Id: formData.DocType_Id }; // ส่งในรูปแบบ Object
      const values = formatValues(formData);
      const res = await updateData("Tb_Set_DocType", values, where);
      if (res) {
        getAlert("OK", "อัปเดตข้อมูลสำเร็จ");
        callInitialize();
      }
    } catch (error) {
      getAlert(
        "FAILED",
        "ไม่สามารถอัปเดตข้อมูลได้ เนื่องจากมีข้อมูลนี้อยู่ในระบบแล้ว"
      );
      return null;
    }
  };

  const handleDelete = async () => {
    try {
      getAlert("C_DIALOG", "ยืนยันการลบข้อมูล", async (isConfirm) => {
        if (isConfirm) {
          await deleteData(
            "Tb_Set_DocType",
            `WHERE DocType_Id = ${selectedData.DocType_Id}`
          );
          getAlert("OK", "ลบข้อมูลสำเร็จ");
          await callInitialize();
        }
      })
    } catch (error) {
      getAlert("FAILED", "ไม่สามารถลบข้อมูลได้ กรุณาลองใหม่อีกครั้ง");
    }
  };

  const handleSubmit = async (e) => {
    try {
      //   if (
      //     !formData.ap_code ||
      //     !formData.ap_name ||
      //     !formData.ap_type ||
      //     !formData.ap_status
      //   ) {
      //     getAlert(
      //       "WARNING",
      //       "โปรดกรอกข้อมูล รหัสเจ้าหนี้ ชื่อเจ้าหนี้  ประเภทเจ้าหนี้  สถานะ"
      //     );
      //     return;
      //   }
      // ตรวจสอบว่าข้อมูลที่แก้ไขว่าซ้ำกับข้อมูลเดิมหรือไม่
      //   if (
      //     formData.ap_code === initialFormData.ap_code &&
      //     formData.ap_name === initialFormData.ap_name
      //   ) {
      //     getAlert(
      //       "WARNING",
      //       "โปรดตรวจสอบข้อมูลอีกครั้ง ข้อมูลนี้มีอยู่ในระบบแล้ว"
      //     );
      //     return;
      //   }
      if (mode === "I") {
        await handleInsertAP();
      } else if (mode === "U") {
        await handleUpdateAP();
      }
      await callInitialize();
      setFormData({
        DocType_Id: 0,
        DocType_Name: "",
        DocType_Status: "Y",
      });
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      getAlert(
        "WARNING",
        "โปรดตรวจสอบข้อมูลอีกครั้ง ข้อมูลนี้มีอยู่ในระบบแล้ว"
      );
      return null;
    }
  };

  return (
    <form>
      <Breadcrumbs
        isShowStatus={mode === "U"}
        items={[
          { name: "ข้อมูลตั้งต้น", url: "/initialdata" },
          { name: name, url: "/docType" },
          { name: mode === "U" ? "เรียกดู" + name : "สร้าง" + name, url: "#" },
        ]}
      />
      <div className="container p-4">
        <div className="card shadow-sm ">
          <div className="card-body">
            <div className="row g-3 mt-1 px-3">
              <div className="col-12 my-1">
                <label className="">ประเภทเอกสาร</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="DocType_Name"
                  value={formData.DocType_Name || ""}
                  onChange={handleChange}
                />
              </div>

              <div className="col-12 mt-2">
                <label className="">สถานะ</label>
                <select
                  className="form-select"
                  name="DocType_Status"
                  value={formData.DocType_Status || "Y"}
                  onChange={handleChange}
                  style={{ color: "black" }}
                >
                  <option value="Y">ใช้งาน</option>
                  <option value="N">ไม่ใช้งาน</option>
                </select>
              </div>
            </div>
            <div className="row mt-4">
              {mode !== "I" ? (
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  {/* ปุ่มลบ */}
                  <button
                    onClick={() => handleDelete()}
                    type="button"
                    className="btn btn-lg shadow text-white"
                    style={{
                      width: "8%",
                      backgroundColor: "#dc3545",
                      fontSize: "16px",
                    }}
                  >
                    ลบ
                  </button>

                  {/* กลุ่มปุ่มยกเลิก และบันทึก */}
                  <div style={{ display: "flex", gap: "20px" }}>
                    <button
                      onClick={() => (window.location.href = "/docType")}
                      type="button"
                      className="btn btn-lg shadow text-white"
                      style={{
                        backgroundColor: "#000000",
                        fontSize: "16px",
                      }}
                    >
                      ยกเลิก
                    </button>
                    <button
                      onClick={() => handleUpdateAP()}
                      type="button"
                      className="btn btn-lg shadow text-white"
                      style={{
                        backgroundColor: "#EF6C00",
                        fontSize: "16px",
                      }}
                    >
                      บันทึก
                    </button>
                  </div>
                </div>
              ) : (
                <div style={{ display: "flex" }}>
                  <FormAction
                    onSubmit={handleSubmit}
                    onUpdate={handleSubmit}
                    onDelete={handleDelete}
                    mode={mode}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default Form;
